export default __webpack_public_path__ + "static/media/Venturer's Leggings of Grinning Skulls.6f889fe9.jpg";